import { AnimalScale } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ProjectState } from 'store/Project/ProjectTypes'

const animalScalesOrder: AnimalScale[] = [
  AnimalScale.Ant,
  AnimalScale.Mouse,
  AnimalScale.Dog,
  AnimalScale.Cow,
  AnimalScale.Elephant,
  AnimalScale.Whale,
]

export const refreshAnimalScaleFilter = (state: ProjectState) => {
  const availableFilters: Set<AnimalScale> = new Set()

  Object.values(state.partTypes).forEach((partType) => {
    const scale = partType.animalScale
    if (scale !== undefined) {
      availableFilters.add(scale)
    }
  })

  const orderedAvailableFilters = Array.from(availableFilters).sort(
    (a, b) => animalScalesOrder.indexOf(a) - animalScalesOrder.indexOf(b),
  )

  const newState: ProjectState = {
    ...state,
    filters: {
      ...state.filters,
      byAnimalScale: {
        ...state.filters.byAnimalScale,
        filter: {
          ...(state.filters.byAnimalScale?.filter || {}),
          availableFilters: orderedAvailableFilters,
          type: 'AnimalScaleFilter',
        },
        active:
          state.filters?.byAnimalScale?.active && availableFilters.size > 0,
      },
    },
  }

  return newState
}
